import { render, staticRenderFns } from "./productTpye.vue?vue&type=template&id=56627f2a&scoped=true"
import script from "./productTpye.vue?vue&type=script&lang=js"
export * from "./productTpye.vue?vue&type=script&lang=js"
import style0 from "./productTpye.vue?vue&type=style&index=0&id=56627f2a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56627f2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56627f2a')) {
      api.createRecord('56627f2a', component.options)
    } else {
      api.reload('56627f2a', component.options)
    }
    module.hot.accept("./productTpye.vue?vue&type=template&id=56627f2a&scoped=true", function () {
      api.rerender('56627f2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scenic-spot/components/productTpye.vue"
export default component.exports